import { SettingOutlined } from '@ant-design/icons'
import { message, Popover } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import TableBox from '../../../Components/TableBox/TableBox'
import FilterLayout from '../../../Layout/FilterLayout'
import apiClient from '../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'
import ProductFilter from './ProductFilter'

export default function Products() {
  const history = useHistory()
  const [products, setProducts] = useState([])

  const onFilter = (params = {}) => {
    apiClient.get('products/get', { params }).then(({ data }) => {
      if (data.result) {
        SET_DATA('products.filterData', { ...params, ...data.pageData })
        setProducts(data.result)
      }
    })
  }

  useEffect(() => {
    onFilter(GET_DATA('products.filterData'))
  }, [])

  const onChangePage = (pageData) => {
    const filterCache = GET_DATA('products.filterData')
    onFilter({ ...(filterCache || {}), ...pageData })
  }

  const onDelete = (id) => {
    apiClient.delete(`products/delete/${id}`).then(({ data }) => {
      if (data && data.result) {
        setProducts(products.filter((item) => item.id !== id))
        message.success('Product Deleted')
      }
    })
  }

  const tableContent = (row) => (
    <div className="action-buttons">
      <ul>
        <li>
          <Link to={`/app/edit-product/${row.id}`}>
            <i className="flaticon-edit-1" /> Edit
          </Link>
        </li>
        <li>
          <li>
            <Link onClick={() => onDelete(row.id)}>
              <i className="flaticon-delete-2" /> Delete
            </Link>
          </li>
        </li>
      </ul>
    </div>
  )

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      render: (v, r) => (
        <div onClick={() => history.push(`/app/edit-product/${r.id}`)}>
          <a>{v}</a>
        </div>
      )
    },
    {
      title: 'Unit',
      dataIndex: 'unit'
    },
    {
      title: 'Unit Price',
      dataIndex: 'unitPrice'
    },
    {
      title: 'Currency',
      dataIndex: 'currency'
    },
    {
      ...(validateAccess('edit-product') && {
        title: 'Action',
        dataIndex: 'custom_action',
        render: (text, row) => (
          <Popover placement="bottomRight" content={tableContent(row)} trigger="click">
            <div className="btn-group">
              <button type="button" className="btn glow dropdown-toggle">
                {' '}
                <SettingOutlined /> <span className="caret" />
              </button>
            </div>
          </Popover>
        )
      })
    }
  ]

  return (
    <FilterLayout filter={<ProductFilter onFilter={onFilter} />}>
      <div className="top-filter-options">
        <h2>Products Overview</h2>
      </div>
      <TableBox
        dataSource={products}
        columns={columns}
        pageData={GET_DATA('products.filterData')}
        onChangePage={onChangePage}
      />
    </FilterLayout>
  )
}
